import React, { useContext } from 'react';
import Block from '@legacy-vfuk/core-block';
import RichTextElement from '../../Elements/RichText';
import { SectionVideoBandProps } from './types/SectionVideoBand.types';
import { Helmet } from 'react-helmet';
import {
  BlockWrapper,
  whiteCSS,
  galleryCSS,
  ContainerWrapper,
  ContentWrapper,
  ImageWrapper,
  VideoBlockWrapper,
  VideoContainerWrapper,
  videoiframe,
  BetaLabel,
  ButtonContent,
} from './styles/SectionVideoBand.styles';
import { DirectionContext } from '../../../../contexts/DirectionContext';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import CtaButtonRow from '../../Elements/CtaButtons';
import getYoutubeScript from '../../../../helpers/youTubeHelper';

const VIDEO_NOT_USED = 'video-not-used';

const SectionVideoIframe = ({
  videoSlug,
  videoSource,
}: {
  videoSlug: string;
  videoSource: string;
}) => {
  const youtubeId = videoSource === 'youtube' ? `ytplayer_${videoSlug}` : '';
  const apiScript = (
    <Helmet>
      <script src="https://www.youtube.com/iframe_api"></script>
      <script>{getYoutubeScript()}</script>
    </Helmet>
  );

  return (
    <VideoBlockWrapper>
      <VideoContainerWrapper>
        {apiScript}
        <iframe
          css={videoiframe}
          id={youtubeId}
          src={`https://www.youtube.com/embed/${videoSlug}?rel=0&enablejsapi=1`}
          className="yt-player-custom"
          type="text/html"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        />
      </VideoContainerWrapper>
    </VideoBlockWrapper>
  );
};

const SectionVideoBand = ({
  content,
  image,
  backgroundColor,
  videoAlignment,
  videoSlug,
  videoSource,
  label,
  buttonRow,
}: SectionVideoBandProps) => {
  const direction = useContext(DirectionContext);
  const backgroundCss = backgroundColor === 'white' ? whiteCSS : galleryCSS;
  const isMediaLeft =
    (videoAlignment === 'left' && direction !== 'rtl') ||
    (videoAlignment === 'right' && direction === 'rtl');

  const theContent = content?.map(item => {
    return (
      <RichTextElement
        key={item.id}
        text={item.text}
        color={item.color}
        textAlign={item.textAlign}
      />
    );
  });

  return (
    <BlockWrapper>
      <Block css={backgroundCss}>
        <ContainerWrapper
          isMediaLeft={videoAlignment === 'left'}
          data-testid="section-video-band-container"
        >
          <ContentWrapper isMediaLeft={isMediaLeft}>
            {label && (
              <BetaLabel>
                <span>{label}</span>
              </BetaLabel>
            )}
            {theContent}
            {buttonRow && (
              <ButtonContent>
                <CtaButtonRow {...buttonRow} spacing={5} />
              </ButtonContent>
            )}
          </ContentWrapper>
          {videoSlug && videoSlug !== VIDEO_NOT_USED && videoSource ? (
            <SectionVideoIframe
              videoSlug={videoSlug}
              videoSource={videoSource}
            />
          ) : (
            image?.gatsbyImageData && (
              <ImageWrapper>
                <GatsbyImage
                  image={getImage(image) as IGatsbyImageData}
                  alt={image.description}
                />
              </ImageWrapper>
            )
          )}
        </ContainerWrapper>
      </Block>
    </BlockWrapper>
  );
};

export default SectionVideoBand;
